import React from 'react';
import classnames from 'classnames';

// Types
import { Attachment, AttachmentFilesTypes } from 'Shared/types/Attachment.type';

// Utils
import * as AttachmentUtils from 'Shared/utils/Attachment.utils';

// Images
import Archive from 'Shared/images/AttachmentTypesIcons/archive.svg';
import Pdf from 'Shared/images/AttachmentTypesIcons/pdf.svg';
import MsWord from 'Shared/images/AttachmentTypesIcons/msword.svg';
import MsExcel from 'Shared/images/AttachmentTypesIcons/msexcel.svg';
import MsPpt from 'Shared/images/AttachmentTypesIcons/msppt.svg';
import Csv from 'Shared/images/AttachmentTypesIcons/csv.svg';
import File from 'Shared/images/AttachmentTypesIcons/file.svg';
import Audio from 'Shared/images/AttachmentTypesIcons/audio.svg';
import Video from 'Shared/images/AttachmentTypesIcons/video.svg';
import Image from 'Shared/images/AttachmentTypesIcons/image.svg';

// Styles
import './AttachmentTypeIcon.scss';

type Props = {
  attachment: Attachment;
  className?: string;
};

const AttachmentTypeLogo = ({ attachment, className }: Props) => {
  const fileType = AttachmentUtils.getFileType({ attachment });

  const getImage = () => {
    switch (fileType) {
      case AttachmentFilesTypes.IMAGE:
        return Image;
      case AttachmentFilesTypes.VIDEO:
        return Video;
      case AttachmentFilesTypes.MSWORD:
        return MsWord;
      case AttachmentFilesTypes.MSEXCEL:
        return MsExcel;
      case AttachmentFilesTypes.MSPPT:
        return MsPpt;
      case AttachmentFilesTypes.CSV:
        return Csv;
      case AttachmentFilesTypes.PDF:
        return Pdf;
      case AttachmentFilesTypes.AUDIO:
        return Audio;
      case AttachmentFilesTypes.ARCHIVE:
        return Archive;
      default:
        return File;
    }
  };

  const baseClassName = 'AttachmentTypeLogo';
  const classes = classnames(baseClassName, className);

  return <img src={getImage()} className={classes} alt={attachment.fileName} />;
};

export default AttachmentTypeLogo;
